export default __webpack_public_path__ + "static/media/regulatory--no-bicycles--g2.10ba3fba.png";